import * as React from 'react';
import { Heading } from '@grandvisionhq/elements';

const FrameInformation = ({ title , subtitle , imageUrl , showImage =true , textOrientation ='vertical' , textHeadingVariant ='subheading1' ,  })=>/*#__PURE__*/ React.createElement("div", {
        "data-t": "frame-information",
        className: `frame-information frame-information--${textOrientation}`
    }, showImage && imageUrl && /*#__PURE__*/ React.createElement("img", {
        src: imageUrl,
        alt: `${title} ${subtitle}`,
        className: "frame-information__image"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "frame-information__text"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: textHeadingVariant,
        component: "h2",
        className: "frame-information__title"
    }, title), /*#__PURE__*/ React.createElement("span", {
        className: "frame-information__subtitle"
    }, subtitle)))
;

export { FrameInformation };
//# sourceMappingURL=FrameInformation.js.map
